import React, { useEffect, useRef } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Menu from "@mui/material/Menu";
import { useAppSelector } from "../../store/hooks";
import { Box, Slider, Typography } from "@mui/material";
import CoinsIcon from "../../Custom-imeges/CreditsScenario/CoinsIcon";
import { useNavigate } from "react-router-dom";
interface CreditScenarioProps {
  showAvailablePackages: boolean;
  setShowAvailablePackages: (flag: boolean) => void;
}
const AddCredits = ({
  showAvailablePackages,
  setShowAvailablePackages,
}: CreditScenarioProps) => {
  const User = useAppSelector((s) => s.User);  
  const usedCredits=(User?.UserCredits?.credits??0)-(User?.UserCredits?.usedCredits??0)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const creditsContainerRef =useRef<HTMLDivElement>(null);
  const handleClickListItem = () => {
    if (creditsContainerRef.current) {
      setAnchorEl(creditsContainerRef.current);
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (showAvailablePackages) {
      handleClose();
    }
  }, [showAvailablePackages]);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAddMoreCredits = () => {
    if (!User.isSubscribed) navigate("/subscription-plans");
    else setShowAvailablePackages(true);
  };

  return (
    User.IsAuthenticated && (
      <div className="Credit-scenario-container">
        <List component="nav">
          <ListItemButton
            id="lock-button"
            aria-haspopup="listbox"
            aria-controls="lock-menu"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClickListItem}
            disableRipple
            disableTouchRipple
            sx={{
              width: "fit-content",
              padding: 0,
              "&.Mui-selected": {
                backgroundColor: "transparent",
              },
              "&:hover": {
                backgroundColor: "transparent",
              },
              "&:focus": {
                backgroundColor: "transparent",
              },
              "&:active": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Box className="credits-container" ref={creditsContainerRef}>
              <CoinsIcon className="coins-icon-style" />
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: "0px",
                  color: "var(--M-background112)",
                }}
              >
                {
                 usedCredits
                } 
              </Typography>
            </Box>
          </ListItemButton>
        </List>
        <Menu
          id="lock-menu"
          className="credit-scenario"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: {
                width: "254px",
                gap: "16px",
                borderRadius: "8px",
                padding: "8px 16px",
                border: "1px solid  #76CFEB33",
                background: "var(--A_backgroundColor89)",
                boxShadow: "0px 0px 20px 0px #0000002E",
                "&::-webkit-scrollbar": { display: "none" },
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              },
            },
          }}
        >
          <Box>
            <Typography className="Free-cards">{User.IsAuthenticated&&!User.isSubscribed?"Free":"Premium"}</Typography>
            <Box className="credit-used">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography className="sub-header">Credits Used</Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography className="rest-of-cards me-2">{User?.UserCredits?.usedCredits +"/"+User?.UserCredits?.credits}</Typography>
                  <CoinsIcon className="custom-icon-grey" size="16" />
                </Box>
              </Box>
              <Slider
                value={User?.UserCredits?.usedCredits}
                min={0}
                max={User?.UserCredits?.credits}
                disabled
                sx={{
                  color: "#12B6EA",
                  height: 8,
                  padding: 0,
                  borderRadius: 8,
                  "&.Mui-disabled": {
                    color: "#12B6EA", // overrides default grey
                  },
                  "& .MuiSlider-thumb": {
                    display: "none",
                  },
                  "& .MuiSlider-track": {
                    border: "none",
                  },
                  "& .MuiSlider-rail": {
                    backgroundColor: "var(--A_backgroundColor90)",
                  },
                }}
              />
            </Box>
            <Box
              className="btn-add-cards open-available-package"
              onClick={handleAddMoreCredits}
            >
              Add more credits
            </Box>
          </Box>
        </Menu>
      </div>
    )
  );
};

export default AddCredits;
